import { render, staticRenderFns } from "./OrderProductView.vue?vue&type=template&id=2362af4e&scoped=true&"
import script from "./OrderProductView.vue?vue&type=script&lang=js&"
export * from "./OrderProductView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2362af4e",
  null
  
)

export default component.exports